export const environment = {
  production: true,
  buildId: '4030112084824381',
  configFile: 'config.json',
};
